class EfEmpresaSelector {
    constructor(gql, $filter, $scope) {
        this.gql = gql
        this.$filter = $filter

        this.empresas = []
        this.apply = (fun) => $scope.$apply(fun)
    }

    $onInit() {
        this.loadingPromise = this.loadEmpresas()
            .then(empresas => {
                this.loadFromCache()

                if (this.ferramenta) {
                    empresas = empresas.filter(empresa => {
                        return empresa.ferramentasDisponiveis.includes(this.ferramenta)
                    })
                }

                this.empresas = empresas.filter(empresa => this.doFilter(empresa))

                if (this.empresas.length === 1) {
                    this.empresaSelecionada = this.empresas[0]
                } else {
                    this.empresaSelecionada = this.empresas.find(filial => filial.id == parseInt(localStorage.getItem(`ef-filiais-selector-${this.contratoId}`)))
                }

                this.setViewValue()
            })

        this.ngModelCtrl.$setValidity('required', false)

        this.ngModelCtrl.$render = () => {
            this.empresaSelecionada = this.ngModelCtrl.$viewValue
        }
    }

    loadFromCache() {
        if (this.cacheKey) {
            this.empresaId = localStorage.getItem(this.cacheKey)
        }
    }

    setViewValue() {
        this.ngModelCtrl.$setValidity('required', this.empresaSelecionada != null)

        if (this.cacheKey && this.empresaSelecionada) {
            localStorage.setItem(this.cacheKey, this.empresaSelecionada.id.toString())
        }

        if (this.empresaSelecionada && this.empresas.length > 1) {
            localStorage.setItem(`ef-filiais-selector-${this.contratoId}`, this.empresaSelecionada.id.toString())
        }

        if (this.ngModelCtrl.$valid) {
            this.ngModelCtrl.$setViewValue(this.empresaSelecionada)
        } else {
            this.ngModelCtrl.$setViewValue(null)
        }
    }

    loadEmpresas() {
        const query = gql`
            query Empresas($empresaId: Int!) {
                usuarioAtual {
                    id
                    permissoes(filter: {empresaId: $empresaId}) {
                        id
                        empresas: filiais {
                            id
                            cnpj
                            razaoSocial
                            ferramentasDisponiveis
                            icms: icmsVigente {
                                id
                                simplesNacional
                            }
                            pisCofins: pisCofinsVigente {
                                id
                                simplesNacional
                                geraCredito
                            }
                            cidade {
                                id
                                nome
                                estado {
                                    id
                                    sigla
                                }
                            }
                        }
                    }
                }
            }
        `

        return this.gql
            .query(query, { empresaId: parseInt(this.contratoId) })
            .then(({ usuarioAtual: { permissoes: [{ empresas }] } }) => {
                return empresas.map(empresa => ({
                    ...empresa,
                    id: parseInt(empresa.id),
                    alc: empresa.cidade.id == 7150, // área de livre comércio, guajará-mirim
                    cidade: empresa.cidade.nome,
                    estado: empresa.cidade.estado.sigla
                }))
            })
    }

    highlight(search, empresa) {
        const cnpj = this.$filter('cpfCnpj')(empresa.cnpj)
        const text = `${cnpj} (${empresa.cidade}/${empresa.estado})`

        return search.split(' ').reduce(this.$filter('highlight'), text)
    }

    doFilter(empresa) {
        if (this.filter) {
            return this.filter({ $empresa: empresa })
        }

        return true
    }
}

angular.module('eficienciaFiscalModule')
    .component('efEmpresaSelector', {
        controller: ['gql', '$filter', '$scope', EfEmpresaSelector],
        bindings: {
            onChange: '&',
            contratoId: '<',
            cacheAs: '@',
            ferramenta: '@',
            label: '@',
            filter: '&?',
            loadingPromise: '=?'
        },
        require: {
            ngModelCtrl: 'ngModel'
        },
        template: `
        <div class="form-group">
            <label>Filial</label>
            <ui-select 
                theme="bootstrap"
                name="empresa"
                ng-model="$ctrl.empresaSelecionada"
                ng-change="$ctrl.setViewValue()" 
                ng-disabled="$ctrl.empresas.length == 1"
                style="width:100%"
                required="true">
                <ui-select-match placeholder="Selecionar uma filial">
                    {{$select.selected.cnpj | cpfCnpj}} ({{$select.selected.cidade}}/{{$select.selected.estado}})
                </ui-select-match>
                <ui-select-choices repeat="empresa in ($ctrl.empresas | filter: $select.search) track by empresa.id">
                    <div ng-bind-html="$ctrl.highlight($select.search, empresa)"></div>
                </ui-select-choices>
            </ui-select>
        </div>
        `
    })
